﻿export default class BtuCalculatorService {

	wattsPerBtu = 3.41214;
	feetPerMeter = 3.28084;
	btuFloorModifier = 0.925;
	btuCeilingModifier = 1.1;
	measurementUnit = Object.freeze({
		feet: 1,
		meters: 2
	});

	calculate(roomDetails: RoomDetails, measurementUnit: number) {

		if (measurementUnit !== this.measurementUnit.feet && measurementUnit !== this.measurementUnit.meters) {
			throw "Invalid measurement unit.";
		}

		const cubicDimensions = this.calculateRoomDimensions(roomDetails, measurementUnit);

		const baseBtu = cubicDimensions *
			roomDetails.roomTypeModifier *
			roomDetails.windowTypeModifier *
			roomDetails.roomExposureModifier;

		const minBtu = baseBtu * this.btuFloorModifier;
		const maxBtu = baseBtu * this.btuCeilingModifier;

		return {
			btuFrom: Math.round(minBtu),
			btuTo: Math.round(maxBtu),
			wattFrom: Math.round(minBtu / this.wattsPerBtu),
			wattTo: Math.round(maxBtu / this.wattsPerBtu)
		};

	}

	calculateRoomDimensions(roomDetails: RoomDetails, measurementUnit: number) {
		const modifier = measurementUnit === this.measurementUnit.feet ? 1 : this.feetPerMeter;
		return (roomDetails.length * modifier) * (roomDetails.width * modifier) * (roomDetails.height * modifier);
	}

};

class RoomDetails {
	length: number;
	width: number;
	height: number;
	roomTypeModifier: number;
	windowTypeModifier: number;
	roomExposureModifier: number;
};
